import { CREATE_PASSWORD, LOGIN, RESET_PASSWORD } from "@/constant/routes"
import CreatePassword from "@/features/auth/pages/create-password";
import  Login  from "@/features/auth/pages/login/Login"
import ResetPassword from "@/features/auth/pages/reset-password/ResetPassword";

export const routes = [
    {
      path: LOGIN,
      element: <Login />,
      isPublic: true,
    },
    {
      path: CREATE_PASSWORD,
      element: <CreatePassword />,
      isPublic: true,
    },
    {
      path: RESET_PASSWORD,
      element: <ResetPassword />,
      isPublic: true,
    },
];
  